/*
Ashraf 09/19/2022 2698947782 fixed validation messages for custom window fields
*/
import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';
import {DISPOSITION} from '../../constants/MicroServiceConstants';

const initialData = {
  dispositionData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'disposition',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDispositionData: (state, action) => {
      state.dispositionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.dispositionData = {};
    },
  },
});

export default slice.reducer;

// Actions

const {fetchDispositionData, fetchStart, fetchError, resetData} = slice.actions;

export const fetchDisposition = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${DISPOSITION}/dispositionCodes/timeline/${accountNumber}`)
      .then((response) => {
        if (response && response.status && response.status === 200) {
          dispatch(fetchDispositionData(response?.data?.timelineResponse));
        } else {
          dispatch(fetchError(response.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const resetDisposition = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
